module.exports = {
      id: "gallery-usage",
      viewBox: "0 0 61 48",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#gallery",
      toString: function () {
        return this.url;
      }
    }